export default "__VITE_ASSET__DIuRnAcP__"